import React from "react";
import "./HamButton.scss";

const menuSwitch = () => {
  let menu = document.querySelector(".mobile_menu");
  let button = document.querySelector(".hamburger-button");
  let body = document.body;
  button.classList.toggle("active");
  if (menu) {
    menu.classList.toggle("active");
  }
  body.classList.toggle("menu-opened")
};

const HamButton = props => {
  return (
    <div className="hamburger-button" onClick={menuSwitch}>
      <i />
      <i />
      <i />
    </div>
  );
};

export default HamButton;
